import * as React from "react";
import { findFieldValue } from "web_modules/underwriter_dashboard/shared";

import Money from "web_modules/Money";

const { Panel, Table } = require("react-bootstrap");

interface IW2PanelProps {
  docs: any;
  header: string;
  setDocId: Function;
  renderCurrent?: Boolean;
  employment?: any;
}

class W2Panel extends React.Component<IW2PanelProps, any> {
  renderW2(doc) {
    return (
      <div>
        <Table className="income_documents_review_table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Wages and Tips</th>
              <th>Tax Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <a onClick={this.props.setDocId.bind(this, doc.id)}>w2 [ID: {doc.id}]</a>
              </td>
              <td>
                <Money value={findFieldValue(doc, "amount_earned") || 0} />
              </td>
              <td>{findFieldValue(doc, "year")}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  render() {
    return (
      <Panel defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>W-2s</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {this.props.docs.map((w2, i) => (
              <div key={i}>{this.renderW2(w2)}</div>
            ))}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default W2Panel;
